module.exports = "query ReturnFormQuery{returnUploadRoute:route(name:\"return_upload\"){url}}"